import type { ReactElement } from 'react'

export function IconTelegram(props: React.SVGProps<SVGSVGElement>): ReactElement {
  return (
    <svg {...props} viewBox={'0 0 24 24'} fill={'none'} xmlns={'http://www.w3.org/2000/svg'}>
      <path
        d={
          'M21.6 2.4L2.9 10.1C1.6 10.6 1.6 11.4 2.7 11.7L7.4 13.2L18.3 6.3C18.8 6 19.3 6.2 18.9 6.6L10.1 14.9L9.8 19.6C10.2 19.6 10.5 19.4 10.8 19.1L13.1 16.9L17.9 20.4C18.8 20.9 19.5 20.6 19.7 19.6L22.9 4.5C23.2 3.4 22.5 2.9 21.6 2.4Z'
        }
        fill={'currentColor'}
      />
    </svg>
  )
}
